import React from 'react';

export const StoreOutlineIcon = ({ width = 48, height = 48 }: { width?: number; height?: number }): JSX.Element => (
  <svg width={width} height={height} viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M43.5 47V26' stroke='black' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M4.5 26V47' stroke='black' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    <g clipPath='url(#clip0_4441_21782)'>
      <path
        d='M27.8351 33.3H20.1651C19.923 33.3007 19.6848 33.36 19.4706 33.4727C19.2564 33.5855 19.0728 33.7484 18.9352 33.9475C18.7977 34.1467 18.7103 34.3762 18.6807 34.6164C18.6511 34.8566 18.68 35.1004 18.7651 35.327L20.0731 38.813C20.1262 38.9558 20.2218 39.079 20.3469 39.166C20.472 39.253 20.6207 39.2998 20.7731 39.3H27.2331C27.3855 39.2998 27.5342 39.253 27.6593 39.166C27.7844 39.079 27.8799 38.9558 27.9331 38.813L29.2411 35.327C29.3263 35.0999 29.3552 34.8556 29.3252 34.6149C29.2953 34.3742 29.2074 34.1444 29.0692 33.9451C28.931 33.7458 28.7465 33.583 28.5315 33.4706C28.3166 33.3583 28.0776 33.2997 27.8351 33.3Z'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M20.25 33.302L21.75 29.552'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M27.75 33.302L26.25 29.552'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M33 34.8C33 42.7 26.068 47.131 24.371 48.1C24.2578 48.1644 24.1298 48.1983 23.9995 48.1983C23.8692 48.1983 23.7412 48.1644 23.628 48.1C21.931 47.132 15 42.7 15 34.8C15 32.413 15.9482 30.1239 17.636 28.436C19.3239 26.7482 21.6131 25.8 24 25.8C26.3869 25.8 28.6761 26.7482 30.364 28.436C32.0518 30.1239 33 32.413 33 34.8Z'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <path d='M22 37V36' stroke='black' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M26 37V36' stroke='black' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    <path
      d='M1.5 15.5C1.58558 16.9352 2.216 18.2835 3.26243 19.2693C4.30886 20.2552 5.69229 20.8043 7.13 20.8043C8.56771 20.8043 9.95114 20.2552 10.9976 19.2693C12.044 18.2835 12.6744 16.9352 12.76 15.5C12.76 16.9905 13.3521 18.42 14.4061 19.4739C15.46 20.5279 16.8895 21.12 18.38 21.12C19.8705 21.12 21.3 20.5279 22.3539 19.4739C23.4079 18.42 24 16.9905 24 15.5C24.0856 16.9352 24.716 18.2835 25.7624 19.2693C26.8089 20.2552 28.1923 20.8043 29.63 20.8043C31.0677 20.8043 32.4511 20.2552 33.4976 19.2693C34.544 18.2835 35.1744 16.9352 35.26 15.5C35.26 16.9905 35.8521 18.42 36.9061 19.4739C37.96 20.5279 39.3895 21.12 40.88 21.12C42.3705 21.12 43.8 20.5279 44.8539 19.4739C45.9079 18.42 46.5 16.9905 46.5 15.5L43.76 3.18C43.6872 2.84656 43.5028 2.54791 43.2374 2.33338C42.972 2.11884 42.6413 2.00124 42.3 2H5.7C5.3587 2.00124 5.02804 2.11884 4.76259 2.33338C4.49715 2.54791 4.31281 2.84656 4.24 3.18L1.5 15.5Z'
      stroke='black'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <defs>
      <clipPath id='clip0_4441_21782'>
        <rect width='24' height='24' fill='white' transform='translate(12 25)' />
      </clipPath>
    </defs>
  </svg>
);
